import { useState } from "react";
import styles from "./styles.module.css";
import VerificaForm from "../../controllers/VerificaForm";
import CampoNumber from "../Campo/CampoNumber";
import { Equipamento } from "../../model/PlanoDeTrabalho/AquisicaoDeEquipamentos";
import CampoTextoLongo from "../Campo/CampoTextoLongo";
import {
  addList,
  editList,
  removeList,
} from "../../controllers/ListOperations";
import { MetaFisica } from "../../model/PlanoDeTrabalho/CronogramaExecucao";
import CampoSelect from "../Campo/CampoSelect";

type Props = {
  refMeta?: Equipamento;
  closeModal: Function;
  list: Equipamento[];
  setList: Function;
  listaMetas: MetaFisica[];
  index?: number;
};

const ModalItem = ({
  refMeta,
  closeModal,
  list,
  setList,
  listaMetas,
  index,
}: Props) => {
  const [metaFisica, setMetaFisica] = useState(
    refMeta?.meta_execucao_fisico_id || 0
  );
  const [especificacao, setEspecificacao] = useState(
    refMeta?.nome_especificacao || ""
  );
  const [quantidade, setQuantidade] = useState(refMeta?.quantidade || 1);
  const [valorUni, setValorUni] = useState(refMeta?.valor_unidade || 1);

  return (
    <form className={styles.formModal}>
      <h2>Adicionar Item</h2>

      <CampoSelect
        title="Meta Fisica"
        setter={setMetaFisica}
        value={metaFisica}
      >
        {listaMetas &&
          listaMetas.map((metaFisica, index) => (
            <option value={index} key={index}>
              {`${metaFisica.etapa}.${
                metaFisica.fase
              } - ${metaFisica.descricao.substring(0, 70)}${
                metaFisica.descricao.length > 70 ? "..." : ""
              }`}
            </option>
          ))}
      </CampoSelect>

      <div className={styles.gridCampos}>
        <CampoNumber
          title="Valor Unitário"
          setter={setValorUni}
          step={0.25}
          value={valorUni}
        />
        <CampoNumber
          title="Quantidade"
          setter={setQuantidade}
          value={quantidade}
        />
      </div>
      <CampoTextoLongo
        title="Nome e Especificação do Equipamento"
        placeholder="Digite o Nome e Especificação do Equipamento"
        required={true}
        customValidity="Preencha com o Nome e Especificação do Equipamento"
        setter={setEspecificacao}
        value={especificacao}
      />

      <hr className={styles.separador} />
      {!refMeta && (
        <input
          type="submit"
          value="+ Adicionar Item"
          className={styles.addBtn}
          onClick={(e) => {
            e.preventDefault();
            if (VerificaForm(e.currentTarget.form)) {
              const item: Equipamento = {
                meta_execucao_fisico_id: metaFisica,
                nome_especificacao: especificacao,
                quantidade: quantidade,
                valor_unidade: valorUni,
                valor_total: valorUni * quantidade,
              };
              addList({ item, list, setList });
              closeModal();
            }
          }}
        />
      )}
      {refMeta !== undefined && index !== undefined && (
        <div className={styles.gridCampos}>
          <input
            type="submit"
            value="Editar Item"
            className={styles.editBtn}
            onClick={(e) => {
              e.preventDefault();
              closeModal();
              if (VerificaForm(e.currentTarget.form)) {
                const item: Equipamento = {
                  meta_execucao_fisico_id: metaFisica,
                  nome_especificacao: especificacao,
                  quantidade: quantidade,
                  valor_unidade: valorUni,
                  valor_total: valorUni * quantidade,
                };
                editList({
                  item,
                  setList,
                  list,
                  index,
                });

                closeModal();
              }
            }}
          />
          <input
            type="submit"
            value="Remover Item"
            className={styles.removeBtn}
            onClick={(e) => {
              e.preventDefault();
              removeList({
                index,
                list,
                setList,
              });
              closeModal();
            }}
          />
        </div>
      )}
    </form>
  );
};

export default ModalItem;
